import React, { FC } from 'react';
import { Box } from '@mui/material';
import { StyledCircleContainer, StyledDeleteIcon, StyledTextContainer } from './ValuationOwnershipConfirmation.styles';

const ValuationOwnershipConfirmation: FC = () => (
  <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
    <StyledCircleContainer display="flex" justifyContent="center" alignItems="center">
      <StyledDeleteIcon fontSize="large" />
    </StyledCircleContainer>
    <StyledTextContainer>
      <p>Are you sure you want to change the valuation ownership?</p>
    </StyledTextContainer>
  </Box>
);
const TITLE
  = 'To proceed, please correct the highlighted errors in the table cells or invalid characters in the approach names:';

export default ValuationOwnershipConfirmation;
